/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as ConsoleRouteImport } from './routes/_console'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ConsoleIndexRouteImport } from './routes/_console.index'
import { Route as ConsoleUsersRouteImport } from './routes/_console.users'
import { Route as ConsoleSupervisionRouteImport } from './routes/_console.supervision'
import { Route as ConsoleRoomsRouteImport } from './routes/_console.rooms'
import { Route as ConsoleRegistrationTokensRouteImport } from './routes/_console.registration-tokens'
import { Route as ConsolePersonalTokensRouteImport } from './routes/_console.personal-tokens'
import { Route as ConsoleAuditingRouteImport } from './routes/_console.auditing'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth.login.index'
import { Route as ConsoleUsersUserIdRouteImport } from './routes/_console.users.$userId'
import { Route as ConsoleRoomsRoomIdRouteImport } from './routes/_console.rooms.$roomId'
import { Route as ConsoleRegistrationTokensTokenIdRouteImport } from './routes/_console.registration-tokens.$tokenId'
import { Route as ConsolePersonalTokensTokenIdRouteImport } from './routes/_console.personal-tokens.$tokenId'

const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleRoute = ConsoleRouteImport.update({
  id: '/_console',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleUsersRoute = ConsoleUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleSupervisionRoute = ConsoleSupervisionRouteImport.update({
  id: '/supervision',
  path: '/supervision',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleRoomsRoute = ConsoleRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleRegistrationTokensRoute =
  ConsoleRegistrationTokensRouteImport.update({
    id: '/registration-tokens',
    path: '/registration-tokens',
    getParentRoute: () => ConsoleRoute,
  } as any)
const ConsolePersonalTokensRoute = ConsolePersonalTokensRouteImport.update({
  id: '/personal-tokens',
  path: '/personal-tokens',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleAuditingRoute = ConsoleAuditingRouteImport.update({
  id: '/auditing',
  path: '/auditing',
  getParentRoute: () => ConsoleRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any)
const ConsoleUsersUserIdRoute = ConsoleUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => ConsoleUsersRoute,
} as any)
const ConsoleRoomsRoomIdRoute = ConsoleRoomsRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => ConsoleRoomsRoute,
} as any)
const ConsoleRegistrationTokensTokenIdRoute =
  ConsoleRegistrationTokensTokenIdRouteImport.update({
    id: '/$tokenId',
    path: '/$tokenId',
    getParentRoute: () => ConsoleRegistrationTokensRoute,
  } as any)
const ConsolePersonalTokensTokenIdRoute =
  ConsolePersonalTokensTokenIdRouteImport.update({
    id: '/$tokenId',
    path: '/$tokenId',
    getParentRoute: () => ConsolePersonalTokensRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ConsoleIndexRoute
  '/callback': typeof CallbackRoute
  '/auditing': typeof ConsoleAuditingRoute
  '/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/rooms': typeof ConsoleRoomsRouteWithChildren
  '/supervision': typeof ConsoleSupervisionRoute
  '/users': typeof ConsoleUsersRouteWithChildren
  '/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/users/$userId': typeof ConsoleUsersUserIdRoute
  '/login/': typeof AuthLoginIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ConsoleIndexRoute
  '/callback': typeof CallbackRoute
  '/auditing': typeof ConsoleAuditingRoute
  '/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/rooms': typeof ConsoleRoomsRouteWithChildren
  '/supervision': typeof ConsoleSupervisionRoute
  '/users': typeof ConsoleUsersRouteWithChildren
  '/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/users/$userId': typeof ConsoleUsersUserIdRoute
  '/login': typeof AuthLoginIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_console': typeof ConsoleRouteWithChildren
  '/callback': typeof CallbackRoute
  '/_console/auditing': typeof ConsoleAuditingRoute
  '/_console/personal-tokens': typeof ConsolePersonalTokensRouteWithChildren
  '/_console/registration-tokens': typeof ConsoleRegistrationTokensRouteWithChildren
  '/_console/rooms': typeof ConsoleRoomsRouteWithChildren
  '/_console/supervision': typeof ConsoleSupervisionRoute
  '/_console/users': typeof ConsoleUsersRouteWithChildren
  '/_console/': typeof ConsoleIndexRoute
  '/_console/personal-tokens/$tokenId': typeof ConsolePersonalTokensTokenIdRoute
  '/_console/registration-tokens/$tokenId': typeof ConsoleRegistrationTokensTokenIdRoute
  '/_console/rooms/$roomId': typeof ConsoleRoomsRoomIdRoute
  '/_console/users/$userId': typeof ConsoleUsersUserIdRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/auditing'
    | '/personal-tokens'
    | '/registration-tokens'
    | '/rooms'
    | '/supervision'
    | '/users'
    | '/personal-tokens/$tokenId'
    | '/registration-tokens/$tokenId'
    | '/rooms/$roomId'
    | '/users/$userId'
    | '/login/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/auditing'
    | '/personal-tokens'
    | '/registration-tokens'
    | '/rooms'
    | '/supervision'
    | '/users'
    | '/personal-tokens/$tokenId'
    | '/registration-tokens/$tokenId'
    | '/rooms/$roomId'
    | '/users/$userId'
    | '/login'
  id:
    | '__root__'
    | '/_auth'
    | '/_console'
    | '/callback'
    | '/_console/auditing'
    | '/_console/personal-tokens'
    | '/_console/registration-tokens'
    | '/_console/rooms'
    | '/_console/supervision'
    | '/_console/users'
    | '/_console/'
    | '/_console/personal-tokens/$tokenId'
    | '/_console/registration-tokens/$tokenId'
    | '/_console/rooms/$roomId'
    | '/_console/users/$userId'
    | '/_auth/login/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ConsoleRoute: typeof ConsoleRouteWithChildren
  CallbackRoute: typeof CallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console': {
      id: '/_console'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console/': {
      id: '/_console/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ConsoleIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/users': {
      id: '/_console/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ConsoleUsersRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/supervision': {
      id: '/_console/supervision'
      path: '/supervision'
      fullPath: '/supervision'
      preLoaderRoute: typeof ConsoleSupervisionRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/rooms': {
      id: '/_console/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof ConsoleRoomsRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/registration-tokens': {
      id: '/_console/registration-tokens'
      path: '/registration-tokens'
      fullPath: '/registration-tokens'
      preLoaderRoute: typeof ConsoleRegistrationTokensRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/personal-tokens': {
      id: '/_console/personal-tokens'
      path: '/personal-tokens'
      fullPath: '/personal-tokens'
      preLoaderRoute: typeof ConsolePersonalTokensRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/auditing': {
      id: '/_console/auditing'
      path: '/auditing'
      fullPath: '/auditing'
      preLoaderRoute: typeof ConsoleAuditingRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_console/users/$userId': {
      id: '/_console/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof ConsoleUsersUserIdRouteImport
      parentRoute: typeof ConsoleUsersRoute
    }
    '/_console/rooms/$roomId': {
      id: '/_console/rooms/$roomId'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof ConsoleRoomsRoomIdRouteImport
      parentRoute: typeof ConsoleRoomsRoute
    }
    '/_console/registration-tokens/$tokenId': {
      id: '/_console/registration-tokens/$tokenId'
      path: '/$tokenId'
      fullPath: '/registration-tokens/$tokenId'
      preLoaderRoute: typeof ConsoleRegistrationTokensTokenIdRouteImport
      parentRoute: typeof ConsoleRegistrationTokensRoute
    }
    '/_console/personal-tokens/$tokenId': {
      id: '/_console/personal-tokens/$tokenId'
      path: '/$tokenId'
      fullPath: '/personal-tokens/$tokenId'
      preLoaderRoute: typeof ConsolePersonalTokensTokenIdRouteImport
      parentRoute: typeof ConsolePersonalTokensRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginIndexRoute: AuthLoginIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ConsolePersonalTokensRouteChildren {
  ConsolePersonalTokensTokenIdRoute: typeof ConsolePersonalTokensTokenIdRoute
}

const ConsolePersonalTokensRouteChildren: ConsolePersonalTokensRouteChildren = {
  ConsolePersonalTokensTokenIdRoute: ConsolePersonalTokensTokenIdRoute,
}

const ConsolePersonalTokensRouteWithChildren =
  ConsolePersonalTokensRoute._addFileChildren(
    ConsolePersonalTokensRouteChildren,
  )

interface ConsoleRegistrationTokensRouteChildren {
  ConsoleRegistrationTokensTokenIdRoute: typeof ConsoleRegistrationTokensTokenIdRoute
}

const ConsoleRegistrationTokensRouteChildren: ConsoleRegistrationTokensRouteChildren =
  {
    ConsoleRegistrationTokensTokenIdRoute:
      ConsoleRegistrationTokensTokenIdRoute,
  }

const ConsoleRegistrationTokensRouteWithChildren =
  ConsoleRegistrationTokensRoute._addFileChildren(
    ConsoleRegistrationTokensRouteChildren,
  )

interface ConsoleRoomsRouteChildren {
  ConsoleRoomsRoomIdRoute: typeof ConsoleRoomsRoomIdRoute
}

const ConsoleRoomsRouteChildren: ConsoleRoomsRouteChildren = {
  ConsoleRoomsRoomIdRoute: ConsoleRoomsRoomIdRoute,
}

const ConsoleRoomsRouteWithChildren = ConsoleRoomsRoute._addFileChildren(
  ConsoleRoomsRouteChildren,
)

interface ConsoleUsersRouteChildren {
  ConsoleUsersUserIdRoute: typeof ConsoleUsersUserIdRoute
}

const ConsoleUsersRouteChildren: ConsoleUsersRouteChildren = {
  ConsoleUsersUserIdRoute: ConsoleUsersUserIdRoute,
}

const ConsoleUsersRouteWithChildren = ConsoleUsersRoute._addFileChildren(
  ConsoleUsersRouteChildren,
)

interface ConsoleRouteChildren {
  ConsoleAuditingRoute: typeof ConsoleAuditingRoute
  ConsolePersonalTokensRoute: typeof ConsolePersonalTokensRouteWithChildren
  ConsoleRegistrationTokensRoute: typeof ConsoleRegistrationTokensRouteWithChildren
  ConsoleRoomsRoute: typeof ConsoleRoomsRouteWithChildren
  ConsoleSupervisionRoute: typeof ConsoleSupervisionRoute
  ConsoleUsersRoute: typeof ConsoleUsersRouteWithChildren
  ConsoleIndexRoute: typeof ConsoleIndexRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleAuditingRoute: ConsoleAuditingRoute,
  ConsolePersonalTokensRoute: ConsolePersonalTokensRouteWithChildren,
  ConsoleRegistrationTokensRoute: ConsoleRegistrationTokensRouteWithChildren,
  ConsoleRoomsRoute: ConsoleRoomsRouteWithChildren,
  ConsoleSupervisionRoute: ConsoleSupervisionRoute,
  ConsoleUsersRoute: ConsoleUsersRouteWithChildren,
  ConsoleIndexRoute: ConsoleIndexRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ConsoleRoute: ConsoleRouteWithChildren,
  CallbackRoute: CallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
